<form [formGroup]="provinceFormGroup" (ngSubmit)="onProvinceFormsSubmit()" class="needs-validation mt-1 form-row">
    <div class="col">
        <div class="form-group" [formGroup]="provinceFormGroup">
            <label class="control-label col-form-label-sm">Province Name</label>
            <div class="input-group input-group-sm">
                <input type="text" class="form-control {{validationErrorsArray['name'] ? 'is-invalid' : ''}}" placeholder="Province Name" name="name" id="name" [required]="true" formControlName="name" />
                <div class="invalid-feedback">
                    {{validationErrorsArray['name'] | translate}}
                </div>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="form-group" [formGroup]="provinceFormGroup">
            <label class="control-label col-form-label-sm">Regions Options</label>
            <select class="form-control form-control-sm {{validationErrorsArray['regionId'] ? 'is-invalid' : ''}}" name="regionId" id="regionId" [required]="true" formControlName="regionId">
                <option *ngFor="let region of regionsOptions" value="{{region.value}}">{{region.label}}</option>
            </select>
            <div class="invalid-feedback">
                {{validationErrorsArray['regionId'] | translate}}
            </div>
        </div>
    </div>
    <div class="col-auto text-right">
        <button type="submit" class="btn btn-primary btn-sm" style="margin-top: 27px;">Add location</button>
    </div>
</form>
